import React from "react";
import config from './../config.js';

import Loading from './../../components/loading.js';
import Notification from 'rc-notification';
let notification = null;
Notification.newInstance({
  style:{top:'45px',right:0}
}, (n) => notification = n);

export default class Servicetutorial extends React.Component {
	constructor(props) {
		super(props);
		let user = {};
	    if(typeof localStorage.token !== 'undefined' && localStorage.token!==''){
	      user = JSON.parse(localStorage.user);
	    }
	    this.state = {
	    	user:user,
	    	page_title:'视频教程 Tutorial',
			loading:true,
      		videourl:'',
      		current_lession:'使用指南-1： 登陆及简介',
      		current_lession_id:'lession_1',
      		lessions:[
      			{id:'lession_1',title:'使用指南-1： 登陆及简介'},
      			{id:'lession_2',title:'使用指南-2： 如何上传影像数据'},
      			{id:'lession_3',title:'使用指南-3： 全脑分割分析功能介绍'},
      			{id:'lession_4',title:'使用指南-4： VBM分析功能使用介绍'},
      			{id:'lession_5',title:'使用指南-5：TBSS分析功能使用介绍'}
      		]
	 	}

	 	this.onChoose = this.onChoose.bind(this);
	 	this.request_video('lession_1');
	}

	onChoose(item){
		const me = this;
		if(item.id===me.state.current_lession_id) return;
		me.setState({
			loading:true,
			current_lession_id:item.id,
			current_lession:item.title
		});
		me.request_video(item.id);
	}


	notify(message) {
		notification.notice({
			content: <span>{message}</span>,
			duration:4,
			style:{
				'bottom':0,
				'right':0
			}
		});
	}


	request_video(id){
		const me = this;
		fetch(config.host + '/user_tutorial/index/?userid='+me.state.user.id+'&lession='+id,{
	      method:'get',
	      headers:{
	        "Authorization":localStorage.token
	      }
	    })
	    .then(response=>response.json())
	    .then(json=>{
	      if(json.status===1){
	        me.setState({
	          loading:false,
	          videourl:json.data
	        });
	      }else{
	        me.setState({
	          loading:false
	        });
					me.notify(json.message);
	      }
	    })
	    .catch(function (error) {
	      console.log(error);
	    });
	}

	render() {
		return (
			<div>
				<Loading display={this.state.loading} />
				<div className="container">
					<div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3">
				        <h3>{this.state.page_title} <small>{this.state.current_lession}</small></h3>
				    </div>
				    <hr />
				    <div>
				    	<video id="lessionVideo" src={this.state.videourl} controls="controls" width="100%" height="500" preload="preload">
			              您的浏览器不支持 高级视频播放 标签。
			              </video>
				    </div>

						<div>
              <p className="lead animated fadeInRight"><i className="fa fa-film"></i>  使用指南</p>
              {this.state.lessions.map((item,index)=>{
              	return(<p key={index}><a onClick={()=>this.onChoose(item)} className=" animated fadeInRight">{item.title} <i className="fa fa-play-circle"></i></a></p>)
              })}
            </div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/apps/console/service_tutorial.js